import { FC } from 'react';

import { Bar, BarsContainer, IconWrapper, SpinningRing } from './ChartLoading.styled';

interface ChartLoadingIconProps {
    size?: 'sm' | 'md' | 'lg';
}

const sizeMap = {
  sm: { wrapper: 60, bars: 24, barWidth: 4, gap: 3 },
  md: { wrapper: 80, bars: 32, barWidth: 6, gap: 4 },
  lg: { wrapper: 100, bars: 40, barWidth: 8, gap: 5 },
};

export const ChartLoadingIcon: FC<ChartLoadingIconProps> = ({ size = 'md' }) => {
  const dimensions = sizeMap[size];

  return (
    <div style={{ position: 'relative', width: dimensions.wrapper, height: dimensions.wrapper }}>
      <SpinningRing style={{ width: dimensions.wrapper + 8, height: dimensions.wrapper + 8 }} />
      <IconWrapper style={{ width: dimensions.wrapper, height: dimensions.wrapper }}>
        <BarsContainer style={{ height: dimensions.bars, gap: dimensions.gap }}>
          <Bar $delay={0} $height={dimensions.bars * 0.5} style={{ width: dimensions.barWidth }} />
          <Bar $delay={0.1} $height={dimensions.bars * 0.8} style={{ width: dimensions.barWidth }} />
          <Bar $delay={0.2} $height={dimensions.bars * 0.6} style={{ width: dimensions.barWidth }} />
          <Bar $delay={0.3} $height={dimensions.bars * 1} style={{ width: dimensions.barWidth }} />
        </BarsContainer>
      </IconWrapper>
    </div>
  );
};
